services.service('UserService', [
    '$rootScope', 'API', 'UserModel', 'LocalStorage', 'Storage', '$state', 'constants', 'Onesignal', 'CustomerEventsService', 'IntercomService',
    function ($rootScope, API, UserModel, LocalStorage, Storage, $state, Const, Onesignal, CustomerEventsService, IntercomService) {
        var self = this;
        self.user = new UserModel();

        this.login = function (data) {
            self.user.onLogin(data);
            self.user.loggedIn = true;
            Storage.load(['withdrawalMethods','localBanks'])
            self.subscribe();

            self.oneSignalLogin();
            IntercomService.sendUserDetails(self.user);
        };

        /**
         * @return {UserModel}
         */
        this.get = function () {
            return self.user;
        };

        this.subscribe = function () {
            API.subscribe('MT4UpdateBalance', function (data) {
                self.user.updateBalance(data);
                $rootScope.$emit('pnl');

                if (data.Order > 0) {
                    CustomerEventsService.trackEvent(CustomerEventsService.events.BalanceUpdate, {
                        tradingAccount: data.login,
                        server: data.live ? 'live' : 'demo',
                        profit: data.Profit,
                        orderId: data.Order,
                        comment: data.comment
                    });
                }
            });
        };

        this.clear = function () {
            log('clear user service');
            self.user && API.unsubscribe('MT4UpdateBalance');
            self.user = new UserModel();

            self.oneSignalLogout();
        };

        this.kycCheck = function () {
            if (!Const['kycCheck'] || (Const['kycCheck'] && self.user.complianceStatus === 'approved')) {
                return;
            }

            if (self.user.complianceStatus && self.user.complianceStatusNegative) {
                return $state.go('kycCheck', {cache: false})
            }
        };

        this.oneSignalLogin = function () {
            Onesignal.setUserId(self.user.customerId);
            Onesignal.setTag("compliance_status", self.user.complianceStatus);
            Onesignal.setTag("ftd", self.user.funded);
            Onesignal.setTag("currency", self.user.baseCurrency);

            // set account type tag, if no live or live w/o FTD - DEMO, if live and FTD - LIVE
            Onesignal.setTag('account_type', (self.user.funded && self.user.isLiveAccounts() > 0) ? 'LIVE' : 'DEMO')
        }

        this.oneSignalLogout = function () {
            //Onesignal.removeUserId();
        }

        return this;
    }]);
